import { compose, prop } from 'ramda';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getView = compose(prop('view'), getRoot);
export const getCampaignId = compose(prop('campaignId'), getRoot);
export const getStructure = compose(prop('structures'), getRoot);
export const getContextUser = compose(prop('contextUser'), getRoot);
export const getHasSubordinates = compose(prop('hasSubordinates'), getRoot);
